class CartDrawer {
	constructor(el) {
		this.el = el;
		this.isOpen = false;
		this.timeline = null;

		if (!this.el) return;


    this.bindUI();
		this.setupAnimation();
		this.bindEvents();
		
		// Instance globale pour usage externe
		window.drawerUIInstance = this;

		// Gestion du resize pour mobile
		window.addEventListener('resize', () => {
			if (this.isOpen) this.updatePosition();
		});
	}

	bindUI() {
		this.overlay = this.el.querySelector('[data-cart-drawer-overlay]');
		this.closeButton = this.el.querySelector('[data-cart-drawer-close]');
		this.inner = this.el.querySelector('[data-cart-drawer-inner]');
		this.openButtons = document.querySelectorAll('[data-cart-icon], [data-cart-drawer-open]');
	}

	setupAnimation() {
		this.timeline = gsap.timeline({
			paused: true,
			onStart: () => {
				this.el.classList.remove('hidden');
				document.body.style.overflow = 'hidden';
			},
			onReverseComplete: () => {
				this.el.classList.add('hidden');
				document.body.style.overflow = '';
			}
		});

		this.timeline.from(this.overlay, {
			opacity: 0,
			duration: 0.5,
			ease: 'power2.inOut'
		}, "start");

		this.timeline.from(this.inner, {
			x: "100%",
			duration: 0.5,
			ease: 'power2.inOut'
		}, "start");
	}

	bindEvents() {
		// Boutons d'ouverture
		this.openButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				// Empêcher l'ouverture du drawer sur la page cart
				if (document.querySelector('[data-cart-page]')) return;
				if (!this.isOpen) this.open();
			});
		});

		// Boutons de fermeture
		this.closeButton?.addEventListener('click', () => this.close());
		this.overlay?.addEventListener('click', () => this.close());

		// Fermeture avec Escape
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen) {
				this.close();
			}
		});

		// Fermeture quand le header s'ouvre
		document.addEventListener('header:open', () => this.close());
	}

	updatePosition() {
		// Mobile uniquement (max-width: 1024px)
		if (window.innerWidth > 1024) {
			this.el.style.top = '';
			this.el.style.height = '';
			return;
		}
		const header = document.querySelector('.js-header-group');
		if (!header) return;
		const headerHeight = header.offsetHeight;
		this.el.style.top = `${headerHeight}px`;
		this.el.style.height = `calc(100dvh - ${headerHeight}px)`;
	}

	open() {
		if (this.isOpen) return;
		this.updatePosition();
		this.isOpen = true;
		this.timeline.play();
	}

	close() {
		if (!this.isOpen) return;
		this.isOpen = false;
		this.timeline.reverse();
	}
}

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-cart-drawer]').forEach(element => {
		new CartDrawer(element);		
		element.CartManagerInstance = new CartManager(element, 'cart-drawer');
	});
});
